import { render, staticRenderFns } from "./PaymentDialog.vue?vue&type=template&id=65181bce&scoped=true"
import script from "./PaymentDialog.vue?vue&type=script&lang=js"
export * from "./PaymentDialog.vue?vue&type=script&lang=js"
import style0 from "./PaymentDialog.vue?vue&type=style&index=0&id=65181bce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65181bce",
  null
  
)

export default component.exports